import AuthLogin from "@components/auth/buttons/login";
import { InternalButton } from "@sharedComponents/buttons";
import useShowNewHeader from "@hooks/use-show-new-header";

import styles from "./main.module.scss";

const UnAuthenticatedRightSection = ({ className = "" }) => {
  const showNewHeader = useShowNewHeader();

  return (
    <AuthLogin className={styles.authLogin}>
      <InternalButton styleType="no-style" className={`${styles.accessLink} ${className}`}>
        <span className={`${styles.loginText} ${showNewHeader ? styles.newLoginLink : ""}`}>Login</span>
      </InternalButton>
    </AuthLogin>
  );
};

export default UnAuthenticatedRightSection;
